export { default } from './ParallaxImage'
